import { useQuery } from 'react-query';
import {
  type BuddyPreferencesResponse,
  getBuddyPreferences
} from '../../services/findBuddyService';

export function useGetBuddyPreferences() {
  return useQuery<BuddyPreferencesResponse>(['myBuddyPreferences'], () => getBuddyPreferences());
}
